import {FC} from 'react'
import {Button} from 'shared/ui/buttons'
import {LockOpenWhite} from 'shared/ui/icons'
import styles from './styles.module.scss'

type ConfirmButtonProps = {
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
}

export const ConfirmButton: FC<ConfirmButtonProps> = ({onClick, type}) => {
  return (
    <div className={styles.confirmBtnContainer}>
      <Button
        type={type}
        fullwidth
        styleType='primary'
        onClick={onClick}
        className={styles.footerBtnConfirm}
      >
        Pay with card
      </Button>
      <div className={styles.secure}>
        <LockOpenWhite />
        Payments are secure and encrypted
      </div>
    </div>
  )
}
